import React from "react";
import PropTypes from "prop-types";

import { setAccessToken, setUserType } from "utils/helpers";

class EmptyWebView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.children = props.children;
  }

  componentWillMount() {
    const {
      location: { query },
    } = this.props;
    // @TODO Review if this view is used to add the new localStorage.getItem('injectedToken');
    const accessToken =
      query.access_token || localStorage.getItem("injectedToken");
    const inAsAnon = query.InAsAnon;
    if (accessToken) {
      setAccessToken(accessToken);
      setUserType(inAsAnon);
    }
  }

  render() {
    return <div style={{ paddingBottom: "40px" }}>{this.children}</div>;
  }
}

EmptyWebView.propTypes = {
  location: PropTypes.object,
  children: PropTypes.node,
};

export default EmptyWebView;
